import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { reviews } from '../data/reviews';

/** Solo se muestra cuando data/reviews.ts tiene reseñas reales de compradores. */
export function Reviews() {
  if (reviews.length === 0) return null;
  return <section aria-labelledby="reviews-heading" className="topo-light w-full bg-paper text-pine" data-id="element-309" data-mp="2madye8f86l0h">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-310" data-mp="2r8ff4mp6i88s">
        <div className="text-center" data-id="element-311" data-mp="2w93bzp039jax">
          <p className="eyebrow text-ember-deep" data-id="element-312" data-mp="2w8205ib90ss5">From the bench</p>
          <h2 id="reviews-heading" className="trail-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-313" data-mp="309x3stgnji93">
            What techs are seeing in their shops
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-pine-soft" data-id="element-314" data-mp="3f0crqg0gd4ay">
            Small engine techs and shop owners using Small Engine Diagnostic
            Pro at the bench.
          </p>
        </div>

        <ul className="mt-10 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-315" data-mp="2rcdw5i1stzcw">
          {reviews.map(review => <li key={review.name} className="flex" data-id="element-316" data-mp="2mcj7ll5hxlv0">
              <figure className="flex w-full flex-col border-t-2 border-ember pt-5" data-id="element-317" data-mp="2mfxb4wpwc141">
                <blockquote className="text-[17px] leading-relaxed text-pine" data-id="element-318" data-mp="2hgke5j5b9dnq">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-319" data-mp="3a3om9wzpa83q">
                  <span aria-hidden="true" className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-forest font-display text-base text-paper" data-id="element-320" data-mp="354289lc1sntv">
                    {initials(review.name)}
                  </span>
                  <span className="min-w-0 text-xs text-pine-soft" data-id="element-321" data-mp="3stmtkavobx6b">
                    <span className="block text-[14px] font-bold text-pine" data-id="element-322" data-mp="3suxwy9l7j2ww">
                      {review.name}
                    </span>
                    {review.role}
                    <span className="mt-0.5 flex items-center gap-1 text-pine-muted" data-id="element-323" data-mp="1m6fhn63an7xr">
                      <MapPinIcon className="h-3 w-3 flex-none" aria-hidden="true" data-id="element-324" data-mp="1r4qs9j1exmh1" />
                      {review.city}, {review.country}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2);
}